import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import Logo from '../Logo'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import ExperimentPanelButton from './ExperimentPanelButton'

const HeaderContainer = styled.div`
  padding: ${rem(14)} 0;
  display: flex;
  justify-content: center;
`

const PaddedLogo = styled(Logo)`
  padding: 0 ${rem(8)};
  align-items: center;
  height: unset;
  width: ${rem(34)};
`

function SecurePaymentHeaderCheckout() {
  const isMobile = useScreenSizeOnly('mobile')

  return <HeaderContainer>
    <Group direction="horizontal" verticalAlign="center" gap={8}>
      {!isMobile &&
        <PaddedLogo tabletVariant="icon" mobileVariant="icon" desktopVariant="icon" />}
      <Heading variant="heading6">
        Secure checkout
      </Heading>
      <ExperimentPanelButton />
    </Group>
  </HeaderContainer>
}

export default SecurePaymentHeaderCheckout
